import { defineComponent } from "vue";

import { AuthorizedContact } from "../../../../../../models/authorized-contact";

import ErrorMessageHandler from "../../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import AuthorizedContactRow from "../AuthorizedContactRow/AuthorizedContactRow.vue";

export default defineComponent({
    components: {
        ErrorMessageHandler,
        AuthorizedContactRow
    },
    props: {
        totalContacts: {
            type: Number
        },
        updateContact: {
            type: Function
        },
        deleteContact: {
            type: Function
        },
        getAuthorizedContacts: {
            type: Function
        },
        isReOrderRequested: {
            type: Boolean,
            default: false
        },
        contactRolesEnum: {
            type: Array,
            default: []
        },
        relationshipsEnum: {
            type: Array,
            default: []
        },
        cahpsSurveyContactEnum: {
            type: Array,
            default: []
        },
        patientId: {
            type: String
        },
        patientPrimaryAddress: {
            type: Object
        },
        cahpsSurveyRecipientIndex: {
            type: Number,
            default: -1
        },
        contacts: {
            type: Array<any>,
            default: []
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        isError: {
            type: Boolean,
            default: false
        },
        updateIndices: {
            type: Function
        }
    },
    data() {
        return {
            loadingCount: 3,
            columns: 9
        };
    },

    emits: ["update:cahpsSurveyRecipientIndex"],

    watch: {
        contacts() {
            if (this.contacts?.length > 0) {
                this.$emit(
                    "update:cahpsSurveyRecipientIndex",
                    this.contacts.findIndex((contact: any) => contact.cahpsSurvey > 0)
                );
            }
        }
    },

    computed: {
        hasData() {
            return this.contacts?.length > 0;
        }
    },
    methods: {
        moveUp(currentPosition: number) {
            let newPosition = currentPosition - 1;
            this.moveContact(currentPosition, newPosition);
        },
        moveDown(currentPosition: number) {
            let newPosition = currentPosition + 1;
            this.moveContact(currentPosition, newPosition);
        },
        moveContact(currentPosition: number, newPosition: number) {
            if (!!this.contacts) {
                if (currentPosition >= this.contacts.length || currentPosition < 0) {
                    return;
                }

                if (newPosition >= this.contacts.length || newPosition < 0) {
                    return;
                }

                this.contacts.splice(newPosition, 0, this.contacts.splice(currentPosition, 1)[0]);
                this.updateIndices();
            }
        },
        async deleteAuthorizedContact(contactId: string) {
            await this.deleteContact(contactId);
        },
        async updateAuthorizedContact(contact: AuthorizedContact) {
            await this.updateContact(contact);
        }
    }
});
